function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fromHeadersEntries(entries) {
    const data = {};
    for (const [key, value] of entries){
        const name = normalizeHeaderName(key);
        if (data[name]) {
            data[name].push(value);
        } else {
            data[name] = [
                value
            ];
        }
    }
    return data;
}
function fromHeadersObject(object) {
    const data = {};
    for(const key in object){
        if (object.hasOwnProperty(key)) {
            const name = normalizeHeaderName(key);
            const value = object[key];
            if (value instanceof Array) {
                data[name] = [
                    ...value
                ];
            } else {
                data[name] = [
                    value
                ];
            }
        }
    }
    return data;
}
function normalizeHeaderName(name) {
    return name.trim().toLowerCase().replace(/(?:^|-)./g, (c)=>c.toUpperCase());
}
function keys(rawHeaders) {
    // Provide deterministic iteration.
    return Object.keys(rawHeaders).sort();
}
class Headerz {
    getRawHeaders() {
        const rawHeaders = this.rawHeaders;
        const copy = {};
        // This method returns a copy of the internal structure to avoid
        // modifications affecting the internal object.
        keys(rawHeaders).forEach((key)=>copy[key] = rawHeaders[key].concat());
        return copy;
    }
    getFetchHeaders() {
        const rawHeaders = this.rawHeaders;
        const copy = {};
        keys(rawHeaders).forEach((key)=>copy[key] = rawHeaders[key].join(', '));
        return copy;
    }
    getAll(key) {
        const name = normalizeHeaderName(key);
        const all = this.rawHeaders[name];
        // This method returns a copy of the internal structure to avoid
        // modifications affecting the internal object.
        return all ? all.concat() : [];
    }
    has(key) {
        return this.rawHeaders.hasOwnProperty(normalizeHeaderName(key));
    }
    get(key) {
        var _this_rawHeaders_name;
        const name = normalizeHeaderName(key);
        var _this_rawHeaders_name_;
        return (_this_rawHeaders_name_ = (_this_rawHeaders_name = this.rawHeaders[name]) === null || _this_rawHeaders_name === void 0 ? void 0 : _this_rawHeaders_name[0]) !== null && _this_rawHeaders_name_ !== void 0 ? _this_rawHeaders_name_ : null;
    }
    set(key, value) {
        const name = normalizeHeaderName(key);
        if (value instanceof Array) {
            this.rawHeaders[name] = value;
        } else {
            this.rawHeaders[name] = [
                value
            ];
        }
        return this;
    }
    append(key, value) {
        const name = normalizeHeaderName(key);
        this.rawHeaders[name] = (this.rawHeaders[name] || []).concat(value);
        return this;
    }
    delete(key) {
        const name = normalizeHeaderName(key);
        delete this.rawHeaders[name];
        return this;
    }
    forEach(callback) {
        const rawHeaders = this.rawHeaders;
        keys(rawHeaders).forEach((key)=>{
            if (rawHeaders[key] !== undefined) {
                callback(key, rawHeaders[key], this);
            }
        });
        return this;
    }
    forEachValue(callback) {
        const rawHeaders = this.rawHeaders;
        keys(rawHeaders).forEach((key)=>{
            if (rawHeaders[key] !== undefined) {
                rawHeaders[key].forEach((value)=>callback(key, value, this));
            }
        });
        return this;
    }
    constructor(init = {}){
        _define_property(this, "rawHeaders", void 0);
        if (init instanceof Headers || Array.isArray(init)) {
            this.rawHeaders = fromHeadersEntries(init);
        } else if (init instanceof Headerz) {
            this.rawHeaders = init.getRawHeaders();
        } else {
            this.rawHeaders = fromHeadersObject(init);
        }
    }
}
export { Headerz as default };

//# sourceMappingURL=headers.js.map